import { useDispatch } from "react-redux";
import { TEACHERS_PAYMENTS_MODAL_ACTION_TYPE } from "../../../redux/actions-type";
import UpdateDeleteModal from "../../../globalComponents/Modals/UpdateDeleteModal/UpdateDeleteModal";
import "moment/locale/az";
const TeacherPaymentCard = ({
  data,
  mode,
  cellNumber,
  setOpenMoreModal,
  teacher,
  type,
}) => {
  const dispatch = useDispatch();

  let courses =
    Array.isArray(data.courses) && data.courses.length > 0
      ? data.courses.map((course) => {
          return (
            <p>{`${course?.course?.name} / ${course?.salary || 0} AZN`}</p>
          );
        })
      : "";

  const groups =
    Array.isArray(data.salaries) && data.salaries.length > 0
      ? data.salaries.map((salary, i) => {
          return (
            <div
              key={i}
              style={{
                borderBottom:
                  i === data.salaries.length - 1
                    ? "none"
                    : "0.5px solid #9a9a9a",
                width: "100%",
                padding: "12px",
                boxSizing: "border-box",
              }}
            >
              {salary?.group?.name}
            </div>
          );
        })
      : "";

  const perLessonSalary =
    Array.isArray(data.salaries) && data.salaries.length > 0
      ? data.salaries.map((salary, i) => {
          return (
            <div
              key={i}
              style={{
                borderBottom:
                  i === data.salaries.length - 1
                    ? "none"
                    : "0.5px solid #9a9a9a",
                width: "100%",
                padding: "12px",
                boxSizing: "border-box",
              }}
            >
              {salary?.perLessonSalary || 0}
            </div>
          );
        })
      : "";

  const confirmedLessonsCounts =
    Array.isArray(data.salaries) && data.salaries.length > 0
      ? data.salaries.map((salary, i) => {
          return (
            <div
              key={i}
              style={{
                borderBottom:
                  i === data.salaries.length - 1
                    ? "none"
                    : "0.5px solid #9a9a9a",
                width: "100%",
                padding: "12px",
                boxSizing: "border-box",
              }}
            >
              {salary?.confirmedLessonsCount || 0}
            </div>
          );
        })
      : "";

  const totalGroupSalaries =
    Array.isArray(data.salaries) && data.salaries.length > 0
      ? data.salaries.map((salary, i) => {
          return (
            <div
              key={i}
              style={{
                borderBottom:
                  i === data.salaries.length - 1
                    ? "none"
                    : "0.5px solid #9a9a9a",
                width: "100%",
                padding: "12px",
                boxSizing: "border-box",
              }}
            >
              {salary?.totalGroupSalary || 0}
            </div>
          );
        })
      : "";

  const listData = [
    { key: "Fənn", value: courses },
    { key: "Email", value: data.email },
    { key: "Mobil nömrə", value: data.phone },
    { key: "Email", value: data.email },
  ];

  const updateItem = (modalType) => {
    dispatch({
      type: TEACHERS_PAYMENTS_MODAL_ACTION_TYPE.GET_TEACHERS_PAYMENTS_MODAL,
      payload: {
        data: data,
        openModal: modalType !== "more" ? true : false,
      },
    });
  };

  const openMoreModal = () => {
    updateItem("more");
    setOpenMoreModal(true);
  };

  const doubleClick = () => {
    updateItem("");
  };

  return (
    <>
      {mode === "desktop" ? (
        type === "payment" ? (
          <tr>
            <td>
              <div className="td-con">
                <div className="cell-number">{cellNumber}.</div>
                <div className="table-scroll-text">
                  {data?.teacher?.fullName}
                </div>
              </div>
            </td>

            <td style={{ padding: "0" }}>
              <div
                className="td-con"
                style={{ padding: "0", display: "block" }}
              >
                <div
                  className="table-scroll-text"
                  style={{
                    width: "100%",
                    display: "block",
                    padding: "5px 0",
                  }}
                >
                  {groups}
                </div>
              </div>
            </td>

            <td style={{ padding: "0" }}>
              <div className="td-con" style={{ display: "block" }}>
                <div
                  className="table-scroll-text"
                  style={{
                    width: "100%",
                    display: "block",
                  }}
                >
                  {confirmedLessonsCounts}
                </div>
              </div>
            </td>

            <td style={{ padding: "0" }}>
              <div
                className="td-con"
                style={{ padding: "0", display: "block" }}
              >
                <div
                  className="table-scroll-text"
                  style={{
                    width: "100%",
                    display: "block",
                  }}
                >
                  {perLessonSalary}
                </div>
              </div>
            </td>

            <td style={{ padding: "0" }}>
              <div
                className="td-con"
                style={{ padding: "0", display: "block" }}
              >
                <div
                  className="table-scroll-text"
                  style={{
                    width: "100%",
                    display: "block",
                  }}
                >
                  {totalGroupSalaries}
                </div>
              </div>
            </td>

            <td style={{ width: "120px", background: "white" }}>
              <div className="td-con">
                <div className="table-scroll-text">
                  {data?.totalSalary || 0}
                </div>
              </div>
            </td>
          </tr>
        ) : (
          <tr onDoubleClick={doubleClick}>
            <td>
              <div className="td-con">
                <div className="cell-number">{cellNumber}.</div>
                <div className="table-scroll-text">{data?.fullName}</div>
              </div>
            </td>
            <td>
              <div className="td-con">
                <div className="table-scroll-text">{data?.fin}</div>
              </div>
            </td>
            <td>
              <div className="td-con">
                <div className="table-scroll-text">{data?.seria}</div>
              </div>
            </td>

            <td className="email">
              <div className="td-con">
                <div className="table-scroll-text">{data?.email}</div>
              </div>
            </td>
            <td>
              <div className="td-con">
                <div className="table-scroll-text phone">{data?.phone}</div>
              </div>
            </td>
            <td>
              <div className="td-con">
                <div className="table-scroll-text">{courses}</div>
              </div>
            </td>

            <td>
              <UpdateDeleteModal
                updateItem={updateItem}
                data={data}
                state={teacher}
                openMoreModal={openMoreModal}
                profil="teachers-payment"
              />
            </td>
          </tr>
        )
      ) : (
        <div className="content-box">
          <div className="left">
            <h3>{data?.fullName}</h3>
            <ul>
              {listData.map((item, index) => (
                <li key={index}>
                  <span className="type">{item.key}:</span>
                  <p>{item.value}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </>
  );
};

export default TeacherPaymentCard;
